import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于51影院的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3 md:space-y-4">
          {faqItems.map((faq) => (
            <details
              key={faq.question}
              className="group rounded-2xl bg-background-100 border border-background-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}